"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Customer_module_1 = tslib_1.__importDefault(require("./modules/Customer.module"));
const Session_module_1 = tslib_1.__importDefault(require("./modules/Session.module"));
const loadAccountDeliveryAddressesRootModule = () => ({
    hasRouter: false,
    modules: [(0, Customer_module_1.default)(), (0, Session_module_1.default)()],
});
exports.default = loadAccountDeliveryAddressesRootModule;
